import React from 'react'

// Components
import Modal from 'app/views/components/UIkit/Modal'


const ModalSendReminders = () => (
  <Modal
    id="modal-info-send-reminders"
    title="Send Reminders"
    body={(
      <div>
        <p>
          If this option is checked, HackEDU will send email reminders to anyone assigned
          to this plan. We send reminders more regularly as the end date gets closer and
          only send emails to users who have not completed the plan.
        </p>
        <p>
          Individuals can opt-out of these emails from their accounts.
        </p>
        <p className="uk-text-right">
          <button className="uk-button uk-button-primary uk-modal-close" type="button">
            Ok
          </button>
        </p>
        <button
          className="uk-modal-close-outside"
          data-uk-close
          type="button"
        />
      </div>
    )}
  />
)


export default ModalSendReminders
